import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Dialog from '@mui/material/Dialog';
import TeamManager from './TeamManager';
import {AppCTX} from '../data/AppContext';
import SearchPlaces from './SearchPlaces';

export default function SearchAppBar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [showTeamManager, setShowTeamManager] = React.useState(false);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleTeamClick = () => {
    handleMenuClose();
    setShowTeamManager(true);
  };

  const handleCloseTeamManager = () => {
    setShowTeamManager(false);
  };

  return (
    <AppBar position="static">
      <Toolbar sx={{ padding: 0 }}>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          aria-controls={open ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleMenuClick}
          sx={{ ml: 2, mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: { xs: 'flex', sm: 'block' } }}>
          <SearchPlaces />
        </Box>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              bgcolor: '#181818',
              color: '#fff',
              '& .MuiMenuItem-root': {
                color: '#fff',
                '&:hover': {
                  bgcolor: '#222',
                },
              },
            },
          }}
        >
          <MenuItem onClick={handleTeamClick}>Team</MenuItem>
        </Menu>
        <Dialog open={showTeamManager} onClose={handleCloseTeamManager} fullScreen TransitionComponent={undefined}>
          <TeamManager onClose={handleCloseTeamManager} />
        </Dialog>
      </Toolbar>
    </AppBar>
  );
}